(function(){
  var cloneIndex=0;
  function wireQuickAdd(clone){
    var pending=false;
    var closeObserver=null;
    function onQuickAdd(event){
      var button=event.target.closest('.quick-add__button');
      if(!button || !clone.contains(button) || button.disabled) return;
      var header=clone.closest('header-drawer');
      var details=header && header.querySelector('details');
      if(!details || !details.open || typeof header.close!=='function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if(pending) return;
      pending=true;
      // Let native close finish its animation and release the menu focus trap
      // before the native chooser/cart receives this one click.
      closeObserver=new MutationObserver(function(){
        if(details.open) return;
        closeObserver.disconnect();
        closeObserver=null;
        pending=false;
        if(button.isConnected && !button.disabled) button.click();
      });
      closeObserver.observe(details,{attributes:true,attributeFilter:['open']});
      header.close();
    }
    clone.addEventListener('click',onQuickAdd,true);
    return function(){
      clone.removeEventListener('click',onQuickAdd,true);
      if(closeObserver) closeObserver.disconnect();
      closeObserver=null;
      pending=false;
    };
  }
  /* Djurslottet 2026-08-20 (prestanda):
     - upd() laser scrollLeft/clientWidth/scrollWidth och skriver sedan en klass.
       Den ar nu rAF-strypt sa den kor hogst en gang per bildruta i stallet for
       en gang per scroll- och resize-handelse.
     - Sakerhetsintervallet gick var 500:e ms i 30 sekunder. MutationObserver:n
       nedan fangar redan en sent inladdad lada, sa intervallet racker i 4 sekunder. */
  function wire(clone){
    var cleanupQuickAdd=wireQuickAdd(clone);
    var rail=clone.querySelector('.dj-mp__rail');
    var arrow=clone.querySelector('.dj-mp__arrow');
    if(!rail) return;
    var raf=0;
    function upd(){ var end=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4; clone.classList.toggle('dj-mp--end', end); }
    function updThrottled(){ if(raf) return; raf=requestAnimationFrame(function(){ raf=0; upd(); }); }
    rail.addEventListener('scroll', updThrottled, {passive:true});
    if(arrow){ arrow.addEventListener('click', function(){ rail.scrollBy({left:Math.round(rail.clientWidth*0.75), behavior:'smooth'}); }); }
    var ro = null;
    if ('ResizeObserver' in window) {
      try {
        ro = new ResizeObserver(updThrottled);
        ro.observe(rail);
      } catch (e) {}
    } else {
      window.addEventListener('resize', updThrottled);
    }
    clone.__djMenuCleanup = function(){
      cleanupQuickAdd();
      if(ro) ro.disconnect();
      else window.removeEventListener('resize', updThrottled);
    };
    setTimeout(upd, 60); setTimeout(upd, 400);
  }
  function inject(){
    var src=document.querySelector('template[data-dj-mp-template]');
    if(!src) return;
    var drawers=document.querySelectorAll('.menu-drawer');
    for(var i=0;i<drawers.length;i++){
      var d=drawers[i];
      if(d.querySelector('.dj-mp-injected')) continue;
      var c=src.content.firstElementChild.cloneNode(true);
      var suffix='-menu-'+(++cloneIndex);
      c.querySelectorAll('form[id]').forEach(function(form){
        form.setAttribute('id',form.getAttribute('id')+suffix);
      });
      c.querySelectorAll('quick-add-component').forEach(function(quickAdd){
        if(Number(quickAdd.dataset.productVariantsCount)>1){
          quickAdd.dataset.alwaysChoose='true';
          quickAdd.dataset.quickAddButton='choose';
        }
      });
      c.classList.add('dj-mp-injected');
      d.appendChild(c);
      wire(c);
    }
  }
  function cleanupTree(node){
    if(!node || node.nodeType!==1) return;
    var clones=[];
    if(node.matches && node.matches('.dj-mp-injected')) clones.push(node);
    if(node.querySelectorAll){
      var nested=node.querySelectorAll('.dj-mp-injected');
      for(var i=0;i<nested.length;i++) clones.push(nested[i]);
    }
    for(var j=0;j<clones.length;j++){
      if(typeof clones[j].__djMenuCleanup==='function') clones[j].__djMenuCleanup();
    }
  }
  function boot(){
    inject();
    var n=0;
    var iv=setInterval(function(){ inject(); if(++n>8){ clearInterval(iv); } }, 500);
    try{
      var t=null;
      var mo=new MutationObserver(function(records){
        for(var i=0;i<records.length;i++){
          for(var j=0;j<records[i].removedNodes.length;j++) cleanupTree(records[i].removedNodes[j]);
        }
        if(t) return;
        t=setTimeout(function(){ t=null; inject(); }, 120);
      });
      var root=document.getElementById('header-group')||document.querySelector('header-component')||document.documentElement;
      mo.observe(root,{childList:true,subtree:true});
    }catch(e){}
  }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
